import { secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.main};
  padding: 3rem 1.4rem;
  border-radius: 1rem;
  text-align: center;
  background: ${secondaryColors.offBlack};
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
    padding: 3rem 5rem;
  }
`;

export const StyledTitle = styled.p`
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: 800;
  font-size: 2.4rem;
  margin-bottom: 1.4rem;

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  }
`;

export const StyledSubtitle = styled.p`
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  margin-bottom: 1.6rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const StyledTimerMessage = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-bottom: 1.1rem;
`;

export const StyledSaber = styled.div<{ onRight?: boolean }>`
  position: absolute;
  transform: rotate(-20deg) scale(0.7);
  top: ${({ onRight }) => (onRight ? 'auto' : '0rem')};
  bottom: ${({ onRight }) => (onRight ? '3rem' : 'auto')};
  left: ${({ onRight }) => (onRight ? 'auto' : '-29rem')};
  right: ${({ onRight }) => (onRight ? '-36rem' : 'auto')};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    top: ${({ onRight }) => (onRight ? 'auto' : '1rem')};
    bottom: ${({ onRight }) => (onRight ? '4rem' : 'auto')};
  }
`;
